import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class VideoV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return  <section className="video-two">
              <div className="container">
                <div className="video-two__block">
                  <h3>How It Works</h3>
                  <p>Integrate our simple script into your website, and Converzex AI instantly handles customer conversations. <br/>It gathers requirements, verifies contact details, and sends qualified leads directly to your dashboard, all in real time and without any manual effort.</p>
                </div>{/* /.video-two__block */}
                <div className="video-two__box text-center">
                  <a href="#" className="video-popup">
                    <img src={publicUrl+"assets/images/resources/app-show-case.png"} alt={ imagealt } />
                  </a>{/* /.video-popup */}
                </div>{/* /.video-two__box */}
              </div>{/* /.container */}
            </section>
        }
}

export default VideoV2